module.exports = __webpack_public_path__ + "media/illustrations/calendar--simple-6a84160c.svg";